// features/workstations/property-dossier/strategy-compare.js
// The v2 differentiator: BRRRR vs Flip vs Hold side-by-side with the
// recommended exit highlighted + a reasoned rationale.

const money = (n) => '$' + Math.round(Number(n) || 0).toLocaleString();

function Stat({ label, value, color }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginTop: 8, color: '#888' }}>
      <span>{label}</span>
      <b style={{ color: color || '#e8e8ea' }}>{value}</b>
    </div>
  );
}

export default function StrategyCompare({ compare }) {
  if (!compare || !Array.isArray(compare.results) || !compare.results.length) return null;
  const rec = compare.recommended;
  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10 }}>
        {compare.results.map((r) => {
          const win = r.strategy === rec;
          const ret = r.infinite ? '∞' : (r.annualizedReturnPct == null ? 'n/a' : `${r.annualizedReturnPct}%`);
          return (
            <div key={r.strategy} style={{
              border: `1px solid ${win ? '#c8a96e' : 'var(--border-3)'}`, borderRadius: 10, padding: 14,
              background: 'var(--surface-3)', boxShadow: win ? '0 0 0 1px #c8a96e inset' : 'none',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 13, fontWeight: 700 }}>{r.label}</span>
                {win && <span style={{ fontSize: 9, padding: '2px 7px', borderRadius: 10, background: '#c8a96e', color: '#1a1a1a', fontWeight: 700 }}>RECOMMENDED</span>}
              </div>
              <Stat label="Return" value={ret} color={win ? '#c8a96e' : undefined} />
              <Stat label="Cash in" value={money(r.cashIn)} />
              {r.cashFlowMo != null && <Stat label="Cash flow" value={`${money(r.cashFlowMo)}/mo`} color={r.cashFlowMo >= 0 ? '#7a9e82' : '#c46050'} />}
              {r.profit != null && <Stat label="Profit" value={money(r.profit)} color="#7a9e82" />}
              <Stat label="Keeps asset" value={r.keepsAsset ? 'Yes' : 'No'} color={r.keepsAsset ? '#e8e8ea' : '#c46050'} />
            </div>
          );
        })}
      </div>
      {compare.rationale && (
        <div style={{ marginTop: 12, fontSize: 13, color: '#b9aee0', background: 'rgba(155,143,196,.10)', border: '1px solid rgba(155,143,196,.4)', borderRadius: 8, padding: '10px 12px' }}>
          ⚖ {compare.rationale}
        </div>
      )}
    </div>
  );
}
